import React from 'react';
import { useNavigate } from 'react-router-dom';

const RefundPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white font-sans text-gray-900">
            <nav className="border-b border-gray-100 p-4 sticky top-0 bg-white/90 backdrop-blur z-10">
                <div className="max-w-4xl mx-auto flex justify-between items-center">
                    <span className="font-bold text-xl flex items-center gap-2">
                        <span className="text-2xl">💰</span> Refund & Cancellation Policy
                    </span>
                    <button onClick={() => navigate('/')} className="text-sm font-bold text-[#ee5b2b] hover:underline">Done</button>
                </div>
            </nav>

            <div className="max-w-4xl mx-auto px-6 py-12 space-y-8">
                <section>
                    <h2 className="text-2xl font-bold mb-4">1. Cancellation Policy</h2>
                    <p className="text-gray-600 leading-relaxed">
                        You may cancel your TableAR subscription at any time. To cancel, you must send an email to{' '}
                        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=pator.explore.tech@gmail.com&su=Subscription%20Cancellation%20Request" target="_blank" rel="noopener noreferrer" className="text-[#ee5b2b] font-bold hover:underline">
                            pator.explore.tech@gmail.com
                        </a>{' '}
                        from the <strong>same email address</strong> you used to sign up for your account. Cancellation requests from any other email address will not be processed.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold mb-4">2. Monthly Plans</h2>
                    <p className="text-gray-600 leading-relaxed">
                        No refunds are provided for partial months. If you cancel mid-month, your subscription will remain active until the end of the current billing period. After that, your account will be downgraded to the Free plan.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold mb-4">3. Annual Plans</h2>
                    <p className="text-gray-600 leading-relaxed">
                        If you have purchased an annual plan and wish to cancel before the year ends, you are eligible for a refund of the <strong>remaining unused full months</strong>. The current month at the time of cancellation is not refundable. For example, if you cancel 4 months into a 12-month plan, you will be refunded for the remaining 8 months.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold mb-4">4. Refund Processing</h2>
                    <p className="text-gray-600 leading-relaxed">
                        All approved refunds will be processed within <strong>7 business days</strong> from the date your cancellation request is confirmed. Refunds will be credited to the original payment method used during purchase.
                    </p>
                </section>

                <section>
                    <h2 className="text-2xl font-bold mb-4">5. How to Request a Cancellation</h2>
                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 space-y-3">
                        <p className="text-gray-700 font-medium">To cancel your subscription and request a refund (if applicable):</p>
                        <ol className="list-decimal list-inside text-gray-600 space-y-2">
                            <li>Send an email to <strong className="text-[#ee5b2b]">pator.explore.tech@gmail.com</strong></li>
                            <li>Use the <strong>same email address</strong> associated with your TableAR account</li>
                            <li>Include your restaurant name and reason for cancellation in the email</li>
                            <li>You will receive a confirmation within 2 business days</li>
                        </ol>
                    </div>
                </section>

                <section>
                    <h2 className="text-2xl font-bold mb-4">6. Contact Us</h2>
                    <p className="text-gray-600 leading-relaxed">
                        If you have any questions about our refund policy, please contact us at{' '}
                        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=pator.explore.tech@gmail.com" target="_blank" rel="noopener noreferrer" className="text-[#ee5b2b] font-bold hover:underline">
                            pator.explore.tech@gmail.com
                        </a>.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default RefundPolicy;
